import i18n from "../i18n";

/**
 * Atajo para el namespace creditCards. Se resuelve en cada llamada, así que
 * sirve tanto en componentes como en helpers que no son componentes (mappers,
 * export a Excel), donde no se puede usar useTranslation.
 */
export const cct = (key, opts) => i18n.t(`creditCards:${key}`, opts);
